"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardFlexWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardFlexWrapper = require("./PropertyCardFlexWrapper.styles");
/**
 * A container for custom content that appears after the data areas of a `PropertyCard`.
 *
 * @since 8.63.0
 */
var PropertyCardFlexWrapper = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardFlexWrapper.StyledPropertyCardFlexWrapper, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardFlexWrapper = PropertyCardFlexWrapper;
PropertyCardFlexWrapper.displayName = 'PropertyCard.FlexWrapper';